import { useState } from "react";
import { api } from "../lib/api";
import { MapPin, Mail, Building2, Phone, Send, CheckCircle2 } from "lucide-react";
import { useSettings } from "../lib/useSettings";

export default function Contatti() {
  const s = useSettings();
  const [form, setForm] = useState({ nome: "", email: "", telefono: "", messaggio: "" });
  const [status, setStatus] = useState("idle");
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading"); setErr("");
    try {
      await api.post("/contact", form);
      setStatus("done");
      setForm({ nome: "", email: "", telefono: "", messaggio: "" });
    } catch (e) {
      setStatus("idle");
      setErr(e?.response?.data?.detail?.[0]?.msg || "Si è verificato un errore. Riprova.");
    }
  };

  return (
    <div data-testid="page-contatti">
      <section className="pt-24 md:pt-32 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#007A3D]">Contatti</span>
          <h1 className="mt-5 font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[1.02] text-[#1A1A1A] max-w-4xl">Raccontaci la tua impresa agricola.</h1>
          <p className="mt-6 text-lg text-[#6B7280] max-w-2xl">Una consulenza iniziale per capire come Betelgez può accompagnarti nella prossima fase di crescita.</p>
        </div>
      </section>
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-7 order-2 md:order-1">
            {status === "done" ? (
              <div data-testid="contact-success" className="bg-[#EAF8F0] border border-[#00A651]/30 rounded-3xl p-10 text-center">
                <CheckCircle2 className="w-12 h-12 text-[#007A3D] mx-auto" />
                <h3 className="mt-4 font-display font-bold text-2xl text-[#1A1A1A]">Messaggio inviato</h3>
                <p className="mt-3 text-[#374151]">Grazie. Ti risponderemo nel più breve tempo possibile.</p>
                <button onClick={() => setStatus("idle")} className="mt-6 text-[#007A3D] underline underline-offset-4">Invia un altro messaggio</button>
              </div>
            ) : (
              <form onSubmit={onSubmit} data-testid="contact-form" className="bg-white border border-[#E5E7EB] rounded-3xl p-6 sm:p-8 md:p-10 space-y-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label className="block text-sm font-medium text-[#1A1A1A] mb-2">Nome *</label>
                    <input required value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })}
                      data-testid="contact-input-nome"
                      className="w-full rounded-xl border border-[#E5E7EB] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EAF8F0] focus:border-[#00A651]" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-[#1A1A1A] mb-2">Telefono</label>
                    <input value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })}
                      data-testid="contact-input-telefono"
                      className="w-full rounded-xl border border-[#E5E7EB] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EAF8F0] focus:border-[#00A651]" />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#1A1A1A] mb-2">Email *</label>
                  <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                    data-testid="contact-input-email"
                    className="w-full rounded-xl border border-[#E5E7EB] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EAF8F0] focus:border-[#00A651]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-[#1A1A1A] mb-2">Messaggio *</label>
                  <textarea required rows={5} value={form.messaggio} onChange={(e) => setForm({ ...form, messaggio: e.target.value })}
                    data-testid="contact-input-messaggio"
                    className="w-full rounded-xl border border-[#E5E7EB] px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#EAF8F0] focus:border-[#00A651]" />
                </div>
                {err && <div className="text-sm text-red-600">{err}</div>}
                <button type="submit" disabled={status === "loading"} data-testid="contact-submit"
                  className="inline-flex items-center gap-2 bg-[#00A651] hover:bg-[#007A3D] disabled:opacity-60 text-white rounded-full px-7 py-4 font-medium transition-colors">
                  <Send className="w-4 h-4" /> {status === "loading" ? "Invio…" : "Prenota una Consulenza"}
                </button>
              </form>
            )}
          </div>
          <aside className="md:col-span-5 order-1 md:order-2">
            <div className="rounded-3xl bg-[#EAF8F0] p-7 md:p-8 space-y-6">
              <h3 className="font-display font-bold text-xl text-[#1A1A1A]">{s.company_name || "Betelgez Srl"}</h3>
              <div className="flex items-start gap-3 text-sm text-[#1A1A1A]"><MapPin className="w-5 h-5 text-[#007A3D] mt-0.5" /><div>{s.address || "Via Roma 83, Seulo (SU)"}</div></div>
              <div className="flex items-start gap-3 text-sm text-[#1A1A1A]"><Building2 className="w-5 h-5 text-[#007A3D] mt-0.5" /><div>Partita IVA<br />{s.vat}</div></div>
              <div className="flex items-start gap-3 text-sm text-[#1A1A1A]"><Phone className="w-5 h-5 text-[#007A3D] mt-0.5" /><div>Telefono<br /><a href="tel:+393462461457" data-testid="contact-phone-link" className="hover:text-[#007A3D] transition-colors">+39 346 2461457</a></div></div>
              <div className="flex items-start gap-3 text-sm text-[#1A1A1A]"><Mail className="w-5 h-5 text-[#007A3D] mt-0.5" /><div>Email<br />{s.email}</div></div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
}
